<div class="wrapper">

  <div class="block-center mt-4 wd-xl">

    <div class="card card-flat">

      <div class="card-header text-center bg-primary">
        <a href="#">
          <img class="block-center rounded img-logo" src="assets/img/logo_horizontal_bco.png" alt="Clube Conecta" />
        </a>
      </div>

      <!-- VALIDAÇÃO DE CPF -->
      @if (fase == 'check') {
        <div class="card-body">
          <p class="txt-cadastro no-padding">Insira seu CPF para<br/>resgate de nova senha.</p>
          <div class="input-group with-focus">
            <input class="form-control border-right-0"
              type="text" placeholder="CPF"
              [(ngModel)]="formResgate.cpf" [ngModelOptions]="{standalone: true}"/>
            <div class="input-group-append">
              <span class="input-group-text text-muted bg-transparent border-left-0">
                <em class="fa fa-user"></em>
              </span>
            </div>
          </div>
          @if (errorMessage != '') {
            <div class="text-danger">{{errorMessage}}</div>
          }
          <button class="btn btn-block btn-primary mt-3" (click)="resgatarSenha()">ENVIAR</button>
          <button class="btn btn-block btn-light mt-3" (click)="goLogin()">VOLTAR</button>
        </div>
      }

      <!-- CONFIRMAÇÃO DE CADASTRO -->
      @if (fase == 'sucesso') {
        <div class="card-body">
          <div class="txt-parabens">
            <p><strong>RESGATE REALIZADO<br/>COM SUCESSO.</strong></p>
            <p></p>
            <p>Sua senha foi enviada para o celular {{celular}}.</p>
          </div>
          <button class="btn btn-block btn-primary mt-3" (click)="goLogin()">
            ACESSAR SISTEMA
          </button>
        </div>
      }

    </div>

  </div>

</div>
